// eslint-disable-next-line import/prefer-default-export
export const EQUIPMENT_DEFAULT = {
  id: null,
  slug: null,
  name: null,
};
